import React, { FC } from "react";
import classNames from "classnames";
import { Input as InputAntd, InputProps } from "antd";

import { BemHelper } from "../../utils";

const bem = new BemHelper("input-onboarding");

export type Props = InputProps & { label?: string };

export const InputOnboarding: FC<Props> = ({ prefix = "", suffix = "", label, ...props }) => {
  return (
    <div
      className={classNames([
        bem.block(),
        props.addonBefore && bem.modifier("start"),
        props.addonAfter && bem.modifier("end"),
      ])}
    >
      {label && <div className={classNames(bem.element("label"))}>{label}</div>}
      <InputAntd
        {...props}
        prefix={prefix}
        suffix={suffix}
        status={props["aria-invalid"] ? "error" : undefined}
      />
    </div>
  );
};
